import {createFeatureSelector, createSelector} from "@ngrx/store";
import * as formProviders from "@core/ngrx/reducers/provider.reducer";

export const selectProvidersState = createFeatureSelector<formProviders.State>('providers');
export const selectLocalProvidersState = createSelector(selectProvidersState, (state: formProviders.State) => state.currentProviders);
